import React from "react";

function MainPage() {
  return <div></div>;
}

export default MainPage;
